<div class="single-select-dropdown" [class.disabled]="disabled">
  <!-- Dropdown Header -->
  <div class="dropdown-header" tabindex="0" (click)="toggleDropDown()">
    <span>{{ selectedItem ? selectedItem[displayKey] : placeholder }}</span>
    <span class="arrow" [class.arrow-up]="showDropDown"></span>
  </div>

  <!-- Dropdown Content -->
  <div class="dropdown-list" *ngIf="showDropDown">
    <input
      type="text"
      [(ngModel)]="searchTerm"
      placeholder="Search..."
      (click)="$event.stopPropagation()"
    />

    <ul>
      <li
        *ngFor="let item of filteredList"
        (click)="selectItem(item)"
        [class.selected]="selectedItem?.[valueKey] === item[valueKey]"
      >
        {{ item[displayKey] }}
      </li>
      <li *ngIf="filteredList?.length === 0" class="no-results">No results found.</li>
    </ul>
  </div>
</div>

